module.exports = __webpack_public_path__ + "static/media/Four.325dbb41.PNG";